/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_Kind_LabelInputs */



/**
* | output |
* | --- |
* | "Type" |
*
* @param {Conversations_Kind_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_kind_label = /** @type {((inputs?: Conversations_Kind_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_Kind_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Type")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type")
	return /** @type {LocalizedString} */ ("Type")
});